import { render, staticRenderFns } from "./TrDisplay.vue?vue&type=template&id=6623f22d&"
import script from "./TrDisplay.vue?vue&type=script&lang=js&"
export * from "./TrDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports